// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Medical($organization_id: uuid!, $patient_id: uuid!) {
  forms: medical_forms_forms(
    where: { organization_id: { _eq: $organization_id } }
    order_by: { created_at: desc }
  ) {
    id
    active
    created_at
    questions {
      ...question_fields
      answers(
        where: { patient_id: { _eq: $patient_id } }
        order_by: { created_at: desc_nulls_last }
        limit: 10
      ) {
        ...answer_fields
      }
    }
  }
  internal_questions: medical_histories_questions(
    where: {
      organization_id: { _eq: $organization_id }
      status: { _eq: active }
      internal: { _eq: true }
    }
    order_by: { order: asc }
  ) {
    ...question_fields
    answers(
      where: { patient_id: { _eq: $patient_id } }
      order_by: { created_at: desc_nulls_last }
      limit: 10
    ) {
      ...answer_fields
    }
  }
}

fragment question_fields on medical_histories_questions {
  id
  name
  category
  type
  alert_type
  alert_conditions
  options
  order
}

fragment answer_fields on medical_histories_answers {
  id
  value
  alert
  created_at
  user {
    id
    vaxiom_person {
      id
      first_name
      last_name
    }
  }
}

`